export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-12 px-4">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <p className="font-logo-main text-xl text-white">
            Athnx<span className="text-blue-400">Gym</span>
          </p>
          <p className="text-white/40 text-sm mt-1">
            A product of <a href="https://athenex.solutions" className="text-blue-400 hover:text-blue-300 transition-colors" target="_blank" rel="noopener noreferrer">Athenex Solutions LLC</a>
          </p>
        </div>

        <div className="flex items-center gap-8 text-sm text-white/40">
          <a href="#features" className="hover:text-white transition-colors">Features</a>
          <a href="#pricing" className="hover:text-white transition-colors">Pricing</a>
          <a href="mailto:support@athenex.solutions" className="hover:text-white transition-colors">Contact</a>
        </div>

        <p className="text-white/30 text-xs">
          &copy; {new Date().getFullYear()} Athenex Solutions LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
